export enum PermissionSameNextDayOption {
  SAME_NEXT_DAY_COMMON_LOGIN = 'same-next-day',
  SAME_NEXT_DAY_LIST = '/same-next-day/entregas',
  SAME_NEXT_DAY_SHOW_DETAIL = '/same-next-day/entrega/',
  SAME_NEXT_DAY_SHOW_NEW_DETAIL = '/same-next-day/detalle/',
}
